/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Extent } from "./Extent";
import { ExtentFromJSON, ExtentFromJSONTyped, ExtentToJSON, ExtentToJSONTyped } from "./Extent";

/**
 *
 * @export
 * @interface ThreediModel
 */
export interface ThreediModel {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly user?: string | null;
  /**
   * The 3Di API version that created this threedimodel.
   */
  readonly threediVersion?: string | null;
  /**
   *
   */
  breachCount?: number | null;
  /**
   *
   */
  revision: string;
  /**
   *
   */
  readonly revisionId?: number | null;
  /**
   *
   */
  readonly revisionHash?: string | null;
  /**
   *
   */
  readonly revisionNumber?: number | null;
  /**
   *
   */
  readonly revisionCommitDate?: Date | null;
  /**
   *
   */
  readonly schematisationId?: number | null;
  /**
   *
   */
  readonly schematisationName?: string | null;
  /**
   *
   */
  readonly repositorySlug?: string | null;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  slug: string;
  /**
   * Disable the model.
   */
  disabled?: boolean;
  /**
   * True if the threedimodel was generated without errors.
   */
  isValid?: boolean | null;
  /**
   *
   */
  epsg?: number | null;
  /**
   * Please describe the model here...
   */
  description?: string | null;
  /**
   * Automatically filled after threedimodel generation.
   */
  storageSpace?: number;
  /**
   *
   */
  readonly storageSpaceHumanized?: string;
  /**
   *
   */
  modelIni?: string | null;
  /**
   *
   */
  extentTwoD?: Extent;
  /**
   *
   */
  extentOneD?: Extent;
  /**
   *
   */
  extentZeroD?: Extent;
  /**
   *
   */
  nodesCount?: number | null;
  /**
   *
   */
  linesCount?: number | null;
  /**
   *
   */
  inpyVersion: string;
  /**
   *
   */
  inpSuccess?: boolean;
  /**
   *
   */
  readonly created?: Date;
}

/**
 * Check if a given object implements the ThreediModel interface.
 */
export function instanceOfThreediModel(value: object): value is ThreediModel {
  if (!("revision" in value) || value["revision"] === undefined) return false;
  if (!("slug" in value) || value["slug"] === undefined) return false;
  if (
    (!("inpyVersion" in (value as Record<string, any>)) &&
      !("inpy_version" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["inpyVersion"] === undefined &&
      (value as Record<string, any>)["inpy_version"] === undefined)
  )
    return false;
  return true;
}

export function ThreediModelFromJSON(json: any): ThreediModel {
  return ThreediModelFromJSONTyped(json, false);
}

export function ThreediModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThreediModel {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    user: json["user"] === undefined ? undefined : json["user"] === null ? null : json["user"],
    threediVersion:
      json["threedi_version"] === undefined
        ? undefined
        : json["threedi_version"] === null
        ? null
        : json["threedi_version"],
    breachCount:
      json["breach_count"] === undefined
        ? undefined
        : json["breach_count"] === null
        ? null
        : json["breach_count"],
    revision: json["revision"],
    revisionId:
      json["revision_id"] === undefined
        ? undefined
        : json["revision_id"] === null
        ? null
        : json["revision_id"],
    revisionHash:
      json["revision_hash"] === undefined
        ? undefined
        : json["revision_hash"] === null
        ? null
        : json["revision_hash"],
    revisionNumber:
      json["revision_number"] === undefined
        ? undefined
        : json["revision_number"] === null
        ? null
        : json["revision_number"],
    revisionCommitDate:
      json["revision_commit_date"] === undefined
        ? undefined
        : json["revision_commit_date"] === null
        ? null
        : parseDateTime(json["revision_commit_date"]),
    schematisationId:
      json["schematisation_id"] === undefined
        ? undefined
        : json["schematisation_id"] === null
        ? null
        : json["schematisation_id"],
    schematisationName:
      json["schematisation_name"] === undefined
        ? undefined
        : json["schematisation_name"] === null
        ? null
        : json["schematisation_name"],
    repositorySlug:
      json["repository_slug"] === undefined
        ? undefined
        : json["repository_slug"] === null
        ? null
        : json["repository_slug"],
    name: json["name"] == null ? undefined : json["name"],
    slug: json["slug"],
    disabled: json["disabled"] == null ? undefined : json["disabled"],
    isValid:
      json["is_valid"] === undefined
        ? undefined
        : json["is_valid"] === null
        ? null
        : json["is_valid"],
    epsg: json["epsg"] === undefined ? undefined : json["epsg"] === null ? null : json["epsg"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    storageSpace: json["storage_space"] == null ? undefined : json["storage_space"],
    storageSpaceHumanized:
      json["storage_space_humanized"] == null ? undefined : json["storage_space_humanized"],
    modelIni:
      json["model_ini"] === undefined
        ? undefined
        : json["model_ini"] === null
        ? null
        : json["model_ini"],
    extentTwoD: json["extent_two_d"] == null ? undefined : ExtentFromJSON(json["extent_two_d"]),
    extentOneD: json["extent_one_d"] == null ? undefined : ExtentFromJSON(json["extent_one_d"]),
    extentZeroD: json["extent_zero_d"] == null ? undefined : ExtentFromJSON(json["extent_zero_d"]),
    nodesCount:
      json["nodes_count"] === undefined
        ? undefined
        : json["nodes_count"] === null
        ? null
        : json["nodes_count"],
    linesCount:
      json["lines_count"] === undefined
        ? undefined
        : json["lines_count"] === null
        ? null
        : json["lines_count"],
    inpyVersion: json["inpy_version"],
    inpSuccess: json["inp_success"] == null ? undefined : json["inp_success"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
  };
}

export function ThreediModelToJSON(json: any): ThreediModel {
  return ThreediModelToJSONTyped(json, false);
}

export function ThreediModelToJSONTyped(
  value?: Omit<
    ThreediModel,
    | "url"
    | "id"
    | "user"
    | "threediVersion"
    | "revisionId"
    | "revisionHash"
    | "revisionNumber"
    | "revisionCommitDate"
    | "schematisationId"
    | "schematisationName"
    | "repositorySlug"
    | "storageSpaceHumanized"
    | "created"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    breach_count: value["breachCount"],
    revision: value["revision"],
    name: value["name"],
    slug: value["slug"],
    disabled: value["disabled"],
    is_valid: value["isValid"],
    epsg: value["epsg"],
    description: value["description"],
    storage_space: value["storageSpace"],
    model_ini: value["modelIni"],
    extent_two_d: ExtentToJSON(value["extentTwoD"]),
    extent_one_d: ExtentToJSON(value["extentOneD"]),
    extent_zero_d: ExtentToJSON(value["extentZeroD"]),
    nodes_count: value["nodesCount"],
    lines_count: value["linesCount"],
    inpy_version: value["inpyVersion"],
    inp_success: value["inpSuccess"],
  };
}
